// extracted by mini-css-extract-plugin
module.exports = {"CheckStyle":"_1RXSeMOzy-3w_p7fCMpas5"};